import create from 'zustand';
import orderbook from 'lib/api/orderbook';
import produce from 'immer';

interface State {
  data: {
    [symbol: string]: any;
  }
  isLoading: {
    [symbol: string]: any;
  }
}

interface Action {
  getCompanyInfo: (symbol: string) => Promise<void>;
}

const initialState = {
  data: {},
  isLoading: {},
};

const useGetCompanyInfo = create<State & Action>((set, get) => ({
  ...initialState,
  getCompanyInfo: async (symbol: string) => {
    if (get().isLoading[symbol]) return;
    set((state) =>
      produce(state, (draft) => {
        draft.isLoading = {
          ...draft.isLoading,
          [symbol]: true,
        };
      }),
    );
    try {
      const response = await orderbook.getCompanyInfo(symbol);

      set((state) =>
        produce(state, (draft) => {
          if (draft.data[symbol]) {
            draft.data[symbol] = response.data.data;
          } else {
            draft.data = {
              ...state.data,
              [symbol]: response.data.data,
            };
          }

          draft.isLoading[symbol] = false;
        }),
      );
    } catch (err) {
      set((state) =>
        produce(state, (draft) => {
          draft.isLoading[symbol] = false;
        }),
      );
    }
  },
}));

export default useGetCompanyInfo;
